import {EmptyControl, HvlQueryModel, MaxLength} from '@hvlng/framework-bff/core';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('KovanHrCodeTextDiscriminatorQueryModel')
export class CodeTextDiscriminatorQueryModel extends HvlQueryModel {
    @MaxLength(25)
    @JsonProperty('code', String, true)
    code?: string = null;

    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText?: string = null;

    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText?: string = null;

    @EmptyControl()
    @JsonProperty('discriminator', String, true)
    discriminator: string = null;

    @EmptyControl()
    @JsonProperty('idList', [Number], true)
    idList?: number[] = null;

    @EmptyControl()
    @JsonProperty('codeList', [String], true)
    codeList?: string[] = null;

    @EmptyControl()
    @JsonProperty('uuidList', [String], true)
    uuidList?: string[] = null;

    @EmptyControl()
    @JsonProperty('orderLevel', Number, true)
    orderLevel: number = null;
}
